import { Component } from 'vue-property-decorator';
import AbstractDisplayField from '../abstract-display-field/abstract-display-field';
import { mixins } from 'vue-class-component';
import moment from 'moment';

@Component({
  name: 'bpc-display-field-time-range',
  components: {},
})
export default class DisplayFieldTimeRange extends mixins(AbstractDisplayField) {
  get formatTimeRange(): string {
    const times = [];
    if (this.item.start_time) {
      times.push(this.item.start_time.substr(0, 5));
    }
    if (this.item.end_time) {
      times.push(this.item.end_time.substr(0, 5));
    }
    return times.join('-');
  }
}
